import React from 'react';
import useTranslation from '../hooks/useTranslation';
import { Helmet } from 'react-helmet';

/* globals CSS_CONFIG */

export interface SiteMetadataProps {
  pageTitle?: string;
}

const SiteMetadata: React.FC<SiteMetadataProps> = ({
  pageTitle,
}): JSX.Element => {
  const { t } = useTranslation();
  const siteName = t('seoContent.title');
  const siteDescription = t('seoContent.description');
  const { LANGUAGE, COUNTRY, HTMLLANG, HTMLDIR } = CSS_CONFIG;
  const language = HTMLLANG || LANGUAGE;
  const locale =
    language && COUNTRY ? `${language}-${COUNTRY.toUpperCase()}` : 'en-GB';

  return (
    <Helmet defaultTitle={siteName} titleTemplate={`%s | ${siteName}`}>
      <title>{pageTitle}</title>
      <html lang={locale} dir={HTMLDIR} />
      <meta name="description" content={siteDescription} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes"
      />
    </Helmet>
  );
};

export default SiteMetadata;
